import React from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import grey from "@material-ui/core/colors/grey";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Select from "@material-ui/core/Select";
import Radio from "@material-ui/core/Radio";
import TextField from "@material-ui/core/TextField";
import RadioGroup from "@material-ui/core/RadioGroup";
import Questionnaire from "./Questionnaire";

function TabContainer({ children, dir }) {
  return (
    <Typography
      component="div"
      dir={dir}
      style={{ padding: 20, backgroundColor: grey["50"] }}
    >
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired
};

const styles = theme => ({
  card: {
    maxWidth: 240
  },
  media: {
    // ⚠️ object-fit is not supported by IE11.
    objectFit: "cover",
    height: 180,
    position: "relative"
  },
  container: {
    padding: 20
  },
  textRight: {
    textAlign: "right"
  },
  helpButton: {
    width: 32,
    height: 32
  },
  flexCenter: {
    display: "flex",
    alignItems: "center"
  },
  duracion: {
    justifyContent: "flex-end",
    color: grey["600"],
    fontWeight: 500
  },
  time: {
    justifyContent: "flex-end"
  },
  iconDate: {
    fontSize: 24,
    marginRight: 5
  },
  durationOverImageContainer: {
    position: "absolute",
    right: 25,
    top: "50%",
    color: "#fff"
  },
  leftIcon: {
    marginRight: theme.spacing.unit * 0.5
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  },
  iconSmall: {
    fontSize: 20
  },
  buttonDanger: {
    color: "#FFF",
    textTransform: "initial",
    paddingRight: 0
    //textShadow: '1px 1px 1px rgba(109, 109, 109, 1)'
  },
  formControl: {
    margin: 0,
    minWidth: 120
  },
  mt20: {
    marginTop: 20
  },
  group: {
    margin: `${theme.spacing.unit}px 0`
  },
  appBar: {
    background: "transparent",
    backgroundColor: "#fff",
    borderBottom: "1px solid #f5f5f5"
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  }
});

class OngoingTestDetailForm extends React.Component {
  state = {
    selectedStartDate: null,
    selectedEndDate: null,
    appBar: {
      background: "transparent",
      backgroundColor: "#fff",
      borderBottom: "1px solid #f5f5f5"
    },
    activeTab: 0,
    age: "",
    age1: "",
    gender: "female",
    received: "0",
    reference: ""
  };

  handleTabChange = (event, value) => {
    this.setState({
      activeTab: value
    });
  };

  handleChange = event => {
    this.setState(
      {
        [event.target.name]: event.target.value
      },
      async () => {
        console.debug(this.state);
      }
    );
  };

  render() {
    const { classes, invitation } = this.props;
    // console.log("invitation", invitation);

    return (
      <form>
        <div>
          <AppBar
            position="static"
            color="default"
            className={classes.appBar}
            elevation={0}
          >
            <Tabs
              value={this.state.activeTab}
              onChange={this.handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              scrollable={window.innerWidth < 412}
              fullWidth={window.innerWidth >= 412}
              scrollButtons="auto"
            >
              <Tab label="Cuestionario" />
              <Tab label="Muestras" />
              <Tab label="Requisitos" disabled />
              <Tab label="Detalles" disabled />
            </Tabs>
          </AppBar>

          {this.state.activeTab == 0 && (
            <TabContainer>
              <Grid container spacing={8}>
                {invitation.project.questionnaires.map(
                    (questionnaire, index) => (
                        <Questionnaire
                            questionnaire={questionnaire}
                            key={`${questionnaire.name}${index}`}
                        />
                    )
                )}
              {/*  <Grid item xs={12}>*/}
              {/*    <Typography className={classes.flexCenter} component="div">*/}
              {/*      1. Pregunta sobre como sientes la piel. Percibes algún tipo*/}
              {/*      de escozor en la zona de la mano?*/}
              {/*    </Typography>*/}
              {/*  </Grid>*/}
              {/*  <Grid item xs={12}>*/}
              {/*    <FormControl className={classes.formControl} fullWidth>*/}
              {/*      <Select*/}
              {/*        value={this.state.age}*/}
              {/*        onChange={this.handleChange}*/}
              {/*        inputProps={{*/}
              {/*          name: "age",*/}
              {/*          id: "age",*/}
              {/*          placeholder: "Selecion..."*/}
              {/*        }}*/}
              {/*        displayEmpty*/}
              {/*        className={classes.selectEmpty}*/}
              {/*      >*/}
              {/*        <MenuItem value="" disabled>*/}
              {/*          Selecion...*/}
              {/*        </MenuItem>*/}
              {/*        <MenuItem value={10}>Ten</MenuItem>*/}
              {/*        <MenuItem value={20}>Twenty</MenuItem>*/}
              {/*        <MenuItem value={30}>Thirty</MenuItem>*/}
              {/*      </Select>*/}
              {/*    </FormControl>*/}
              {/*  </Grid>*/}
              {/*</Grid>*/}
              {/*<Grid container spacing={8} className={classes.mt20}>*/}
              {/*  <Grid item xs={12}>*/}
              {/*    <Typography className={classes.flexCenter} component="div">*/}
              {/*      2. Cual opción algún tipo de escozor en la zona de la mano?*/}
              {/*    </Typography>*/}
              {/*  </Grid>*/}
              {/*  <Grid item xs={12}>*/}
              {/*    <FormControl*/}
              {/*      component="fieldset"*/}
              {/*      className={classes.formControl}*/}
              {/*    >*/}
              {/*      <RadioGroup*/}
              {/*        aria-label="Gender"*/}
              {/*        name="gender"*/}
              {/*        className={classes.group}*/}
              {/*        value={this.state.gender}*/}
              {/*        onChange={this.handleChange}*/}
              {/*      >*/}
              {/*        <FormControlLabel*/}
              {/*          value="female"*/}
              {/*          control={<Radio color="primary" />}*/}
              {/*          label="Opcion 1"*/}
              {/*        />*/}
              {/*        <FormControlLabel*/}
              {/*          value="male"*/}
              {/*          control={<Radio color="primary" />}*/}
              {/*          label="Opcion 2"*/}
              {/*        />*/}
              {/*      </RadioGroup>*/}
              {/*    </FormControl>*/}
              {/*  </Grid>*/}
              {/*</Grid>*/}
              {/*<Grid container spacing={8} className={classes.mt20}>*/}
              {/*  <Grid item xs={12}>*/}
              {/*    <Typography className={classes.flexCenter} component="div">*/}
              {/*      3. Pregunta sobre como sientes la piel. Percibes algún tipo*/}
              {/*      de escozor en la zona de la mano?*/}
              {/*    </Typography>*/}
              {/*  </Grid>*/}
              {/*  <Grid item xs={12}>*/}
              {/*    <FormControl className={classes.formControl} fullWidth>*/}
              {/*      <Select*/}
              {/*        value={this.state.age1}*/}
              {/*        onChange={this.handleChange}*/}
              {/*        inputProps={{*/}
              {/*          name: "age1",*/}
              {/*          id: "age-1"*/}
              {/*        }}*/}
              {/*        displayEmpty*/}
              {/*        className={classes.selectEmpty}*/}
              {/*      >*/}
              {/*        <MenuItem value="" disabled>*/}
              {/*          Selecion...*/}
              {/*        </MenuItem>*/}
              {/*        <MenuItem value={10}>Ten</MenuItem>*/}
              {/*        <MenuItem value={20}>Twenty</MenuItem>*/}
              {/*        <MenuItem value={30}>Thirty</MenuItem>*/}
              {/*      </Select>*/}
              {/*    </FormControl>*/}
              {/*  </Grid>*/}
              </Grid>
            </TabContainer>
          )}

          {this.state.activeTab == 1 && (
            <TabContainer>
              <Grid container spacing={8}>
                <Grid item xs={12}>
                  <Typography className={classes.flexCenter} component="div">
                    Confirmación de la recepción de las muestras y verificación
                    de la referencia de la muestra recibida
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <RadioGroup
                      aria-label="He recibido"
                      name="received"
                      className={classes.group}
                      value={this.state.received}
                      onChange={this.handleChange}
                    >
                      <FormControlLabel
                        value="1"
                        control={<Radio color="primary" />}
                        label="Sí, he recibido"
                      />
                      <FormControlLabel
                        value="0"
                        control={<Radio color="primary" />}
                        label="No he recibido"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl className={classes.formControl} fullWidth>
                    <TextField
                      id="referencia"
                      InputLabelProps={{
                        shrink: true
                      }}
                      placeholder="Referencia"
                      fullWidth
                      margin="normal"
                      name="reference"
                      value={this.state.reference}
                      style={{ marginTop: 0 }}
                      onChange={this.handleChange}
                      disabled={this.state.received === "0"}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </TabContainer>
          )}

          {this.state.activeTab == 2 && (
            <TabContainer>
              <Grid container spacing={8}>
                <Grid item xs={12}>
                  <Typography variant="title" paragraph>
                    REQUISITOS
                  </Typography>
                  <Typography paragraph>
                    Sed blandit augue vitae augue scelerisque bibendum. Vivamus
                    sit amet libero turpis, non venenatis urna. In blandit, odio
                    convallis suscipit venenatis, ante ipsum cursus augue.
                  </Typography>
                </Grid>
              </Grid>
            </TabContainer>
          )}

          {this.state.activeTab == 3 && (
            <TabContainer>
              <Grid container spacing={8}>
                <Grid item xs={12}>
                  <Typography variant="title" paragraph>
                    DETALLES
                  </Typography>
                  <Typography paragraph>
                    Sed blandit augue vitae augue scelerisque bibendum. Vivamus
                    sit amet libero turpis, non venenatis urna. In blandit, odio
                    convallis suscipit venenatis, ante ipsum cursus augue.
                  </Typography>
                </Grid>
              </Grid>
            </TabContainer>
          )}
        </div>

        <div className={classes.container}>
          <Grid container spacing={8}>
            <Grid item xs={6}>
              <Button disabled>Cancelar test</Button>
            </Grid>
            <Grid item xs={6} style={{ textAlign: "right" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleSubmit}
                disabled
              >
                Guardar
              </Button>
            </Grid>
          </Grid>
        </div>
      </form>
    );
  }
}

export default withStyles(styles)(OngoingTestDetailForm);



// WEBPACK FOOTER //
// ./src/modules/test/components/OngoingTestDetailForm.js